export default "__VITE_ASSET__CxbSyLAL__"